import React, { useCallback, useMemo, useState } from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Button,
  Dialog,
  Tooltip,
  TextField,
  Box,
} from "@material-ui/core";
import Draggable from "react-draggable";
import DataTable from "react-data-table-component";
import {
  useStyles,
  paperPropsBig,
  paperPropsBig1,
  paperPropsBigFixed,
  paperPropsBigCaiss,
} from "../../../css/muiStyle";
import { customStyles, numberColumn } from "../../../css/datatableStyle";
import Iconn from "@mdi/react";
import { mdiPen } from "@mdi/js";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Add, IndeterminateCheckBox, Search } from "@material-ui/icons";
import { AlertCompo, AutocompleteS } from "../../../js/components";
import { Autocomplete } from "@material-ui/lab";
import ContentEditable from "react-contenteditable";

//add new marque
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const Ref_bdl_err = React.memo((props) => {
  const Gfunc = require("../../../Gfunc");
  const param = props.param;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [control, setControl] = useState(false);
  const [bdlL, setBdlL] = useState([]);
  const [bdl, setBdl] = useState("");
  const [bdlN, setBdlN] = useState("");
  const [bdl2, setBdl2] = useState("");
  const [bdlN2, setBdlN2] = useState("");
  const [data, setData] = useState([]);
  const librery = require("../../../js/data_table_librery");
  const [keyword, setKeyword] = useState("");
  const [msgAr, setMsgAr] = useState("");
  const [msgFr, setMsgFr] = useState("");
  const [msgEn, setMsgEn] = useState("");
  const addTitle = "Gestion des erreurs";
  const service = "_bdl.php";
  const classes = useStyles();
  const labelText3 = "Message FR";
  const labelText4 = "Message EN";
  const labelText5 = "Message AR";
  const labelText2 = "Mot clé";
  const [severity, setSeverity] = useState("info");
  const [openA, setOpenA] = useState(false);
  const [messageA, setMessageA] = useState("");
  const [search, setSearch] = useState("");
  const [, setDel] = useState("");

  //handle alerts properties
  const handleAlert = (open, severity, message) => {
    setOpenA(open);
    setSeverity(severity);
    setMessageA(message);
    setTimeout(function () {
      setOpenA(false);
    }, 5000);
  };

  const fetch = async () => {
    setLoading(true);
    const response = await Gfunc.axiosGetAction("_bdl.php", "getber");
    if (response.data.err && response.data.err !== "-1") {
      alert(response.data.err);
      setOpen(false);
    } else
      Gfunc.axiosResponse(response, () => {
        if (response.data.jData !== undefined) {
          setData(response.data.jData ?? []);
        }
      });
    setLoading(false);
  };

  const handleClickOpen = () => {
    setKeyword("");
    setMsgAr("");
    setMsgFr("");
    setMsgEn("");
    fetch();
    fetchBdl();
    setBdl("");
    setBdlN("");
    setBdl2("");
    setBdlN2("");
    setData([]);
    setOpen(true);
  };

  const handleSubmit = async () => {
    const dat = {
      //bundleId: bdl,
      keyword: keyword,
      msgAr: msgAr,
      msgFr: msgFr,
      msgEn: msgEn,
    };
    const respon = await Gfunc.axiosPostAction("_bdl.php", "addber", dat);
    if (respon.data.err && respon.data.err !== "-1") {
      handleAlert(true, "error", respon.data.err);
    } else
      Gfunc.axiosResponse(respon, () => {
        //props.getConso();
        // data.unshift({date:Gfunc.getDate(),caissier:localStorage.getItem("name"),keyword:keyword,mtn:mtn,conso:respon.data.jData});
        //setOpen(false);
        fetch();
        // fetchBdl();
        // setBdl("");
        //setBdlN("");
        setKeyword("");
        setMsgAr("");
        setMsgFr("");
        setMsgEn("");
        const elem = document.getElementById("iBdl");
        if (elem) elem.focus();
        setControl(!control);
      });
  };

  //delete
  const handleSetData = useCallback(
    (row, att) => {
      Gfunc.removeItemsByAtt(data, row.DT_RowId, att);
      setDel("");
    },
    [data, Gfunc],
  );

  //handle delete
  const handleDelete = useCallback(
    async (row) => {
      const x = window.confirm("Êtes-vous sure de supprimer cet élément?");
      if (x) {
        const response = await Gfunc.axiosPostAction("_bdl.php", "delber", {
          errorId: row.errorId,
        });
        if (response.data.err && response.data.err !== "-1") {
          handleAlert(true, "error", response.data.err);
        } else {
          Gfunc.axiosResponse(response, () => {
            handleAlert(true, "success", "L'élément est supprimé avec succès.");
            handleSetData(row, "DT_RowId");
            setDel(row.errorId);
            setControl(!control);
          });
        }
      }
    },
    [Gfunc, handleSetData, handleAlert],
  );

  //fetch users
  const fetchBdl = useCallback(
    async (serv = "_bdl.php", act = "gets") => {
      const response = await Gfunc.axiosGetAction(serv, act);
      if (response.data.err) {
        handleAlert(true, "error", response.data.err);
      } else {
        Gfunc.axiosResponse(response, () => {
          setBdlL(response.data.jData);
        });
      }
    },
    [Gfunc],
  );

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnEdit = useCallback(
    async (e, row, att, action, id) => {
      const edt1 = e.target.innerHTML;
      const edt = Gfunc.DeleteSpace(edt1);

      if (row[att] !== edt) {
        const attrib = row[att];
        const response = await librery.axiosEdit2(
          service,
          action,
          row,
          edt,
          att,
          id,
          "text",
        );
        if (response.data.err && response.data.err !== "-1") {
          handleAlert(true, "error", response.data.err);
        } else {
          Gfunc.axiosResponse(response, () => {
            row[att] = edt;
            e.target.innerHTML = edt;
          });
        }
        if (response.data.err) {
          e.target.innerHTML = attrib;
        }
      } else {
        e.target.innerHTML = edt;
      }
    },
    [librery, Gfunc],
  );

  const columns = useMemo(
    () => [
      // {
      //   name: labelText1,
      //   minWidth: "135px !important",
      //   selector: (row) => row.origine,
      //   sortable: true,
      //   cell: (row) => (
      //     <AutocompleteS
      //       service={service}
      //       action={"updbew"}
      //       defaultValue={bdlL.filter((e) => e.id !== row.targetId)}
      //       row={row}
      //       list={bdlL}
      //       id={"origineId"}
      //       name="origine"
      //       attr="name"
      //       rowId="errorId"
      //       handleAlert={handleAlert}
      //     />
      //   ),
      // },
      {
        name: labelText2,
        width: "135px !important",
        selector: (row) => row.keyword,
        sortable: true,
        cell: (row) => (
          <ContentEditable
            html={row.keyword !== null ? row.keyword : ""}
            name="keyword"
            data-column="item"
            className="content-editable"
            disabled={false}
            onBlur={(e) => handleOnEdit(e, row, "keyword", "updber", "errorId")}
          />
        ),
      },
      {
        name: labelText3,
        minWidth: "135px !important",
        selector: (row) => row.msgAr,
        sortable: true,
        cell: (row) => (
          <ContentEditable
            html={row.msgFr !== null ? row.msgFr : ""}
            name="msgFr"
            data-column="item"
            className="content-editable"
            disabled={false}
            onBlur={(e) => handleOnEdit(e, row, "msgFr", "updber", "errorId")}
          />
        ),
      },
      {
        name: labelText4,
        minWidth: "135px !important",
        selector: (row) => row.msgEn,
        sortable: true,
        cell: (row) => (
          <ContentEditable
            html={row.msgEn !== null ? row.msgEn : ""}
            name="msgEn"
            data-column="item"
            className="content-editable"
            disabled={false}
            onBlur={(e) => handleOnEdit(e, row, "msgEn", "updber", "errorId")}
          />
        ),
      },
      {
        name: labelText5,
        minWidth: "135px !important",
        selector: (row) => row.msgAr,
        sortable: true,
        cell: (row) => (
          <ContentEditable
            html={row.msgAr !== null ? row.msgAr : ""}
            name="msgAr"
            data-column="item"
            className="content-editable"
            disabled={false}
            onBlur={(e) => handleOnEdit(e, row, "msgAr", "updber", "errorId")}
          />
        ),
      },

      {
        right: true,
        maxWidth: "30px !important",
        cell: (row, index) => {
          return (
            <div className="rowGrid" id="oneIcons" title="Supprimer">
              <IndeterminateCheckBox
                fontSize="small"
                onClick={() => handleDelete(row, index)}
                className={classes.redIcon}
              />{" "}
            </div>
          );
        },
      },
    ],
    [handleDelete],
  );

  //recherche serverside
  const handleSearch = async () => {
    // const results = searchData([...data], search);
    // setData(results);
  };

  function liveSearch(e, search) {
    if (param.liveSearch && search.length > 3) {
      e.preventDefault();
      handleSearch();
    } else {
      if (e.keyCode === 13) {
        e.preventDefault();
        handleSearch();
      }
    }
  }

  function liveSearch2() {
    handleSearch();
  }
  return (
    <div>
      <Button
        className={classes.topTabBtn}
        variant="contained"
        color="secondary"
        onClick={handleClickOpen}
        startIcon={<Iconn path={mdiPen} size={0.7} color={"black"} />}
      >
        Gestion des erreurs
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={paperPropsBigCaiss}
      >
        <DialogTitle
          className={classes.topDivTitle}
          id="draggable-dialog-title"
        >
          {addTitle}
        </DialogTitle>
        <AlertCompo
          severity={severity}
          open={openA}
          setOpen={setOpenA}
          message={messageA}
          dialg={true}
        />
        <DialogContent>
          <fieldset className="fieldsetTop2" id="errorBdl">
            <legend>Gestion des erreurs</legend>
            <ValidatorForm
              id="errorForm"
              onSubmit={handleSubmit}
              onError={(errors) => console.log(errors)}
            >
              {/* <Autocomplete
                disableClearable
                className="smallAuto"
                id="iBdl"
                onChange={(e, newValue) => {
                  //const idf=props.bdlL[Gfunc.getIndex(props.bdlL,newValue,"name")].id
                  setBdl(newValue.id);
                  setBdlN(newValue.name);
                  //fetch(newValue.id);
                }}
                value={{ id: parseInt(bdl), name: bdlN }}
                options={bdlL.filter((e) => e.id !== bdl2)}
                getOptionLabel={(option) => option.name}
                getOptionSelected={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={labelText1}
                    variant="outlined"
                    margin="dense"
                    size="small"
                    required
                  />
                )}
              /> */}

              <TextValidator
                size="small"
                variant="outlined"
                label={labelText2}
                id="iMot"
                name="iMot"
                value={keyword}
                margin="dense"
                className="smallText"
                onChange={(e) => setKeyword(e.target.value)}
              />
              <TextValidator
                size="small"
                variant="outlined"
                label={labelText3}
                id="iMf"
                name="iMf"
                value={msgFr}
                margin="dense"
                className="smallText"
                onChange={(e) => setMsgFr(e.target.value)}
              />
              <TextValidator
                size="small"
                variant="outlined"
                label={labelText4}
                id="iMe"
                name="iMe"
                value={msgEn}
                margin="dense"
                className="smallText"
                onChange={(e) => setMsgEn(e.target.value)}
              />
              <TextValidator
                size="small"
                variant="outlined"
                label={labelText5}
                id="iMa"
                name="iMa"
                value={msgAr}
                margin="dense"
                className="smallText"
                onChange={(e) => setMsgAr(e.target.value)}
              />

              <Button
                className={classes.diagTabBtn}
                type="submit"
                variant="contained"
                color="primary"
                startIcon={<Iconn path={mdiPen} size={0.7} color={"white"} />}
              >
                APPLIQUER
              </Button>
            </ValidatorForm>
          </fieldset>
          <div className="table-header">
            <div className="button-flex-wrapper"></div>
            <div className="search">
              <Box
                sx={{ display: "flex", alignItems: "center", marginTop: "8px" }}
              >
                <Search
                  className={classes.blackIcon}
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                  onClick={(e) => liveSearch2(e)}
                />
                <TextField
                  className="smallText"
                  id="searchBar"
                  variant="outlined"
                  label="Recherche"
                  value={search}
                  size="small"
                  margin="dense"
                  onKeyUp={(e) => liveSearch(e)}
                  onChange={(e) => setSearch(e.target.value)}
                  autoFocus
                />
              </Box>
            </div>
          </div>
          <DataTable
            key={control}
            columns={columns}
            data={Gfunc.searchData([...data], search)}
            pagination
            paginationPerPage={20}
            noDataComponent={param.ErreurData}
            progressPending={loading}
            highlightOnHover
            noHeader={true}
            customStyles={customStyles}
            paginationComponentOptions={{
              rowsPerPageText: "Élément par page:",
              rangeSeparatorText: "sur",
              selectAllRowsItem: true,
              selectAllRowsItemText: "Tous",
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose} color="secondary">
            FERMER
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});
export default Ref_bdl_err;
